import { useContext } from "react";
import { MODES } from "../../commons/constants/user";
import { AppContext } from "../../contexts/AppContext";
import useControlTabs from "../../hooks/useControlTabs";
import StoreOfficial from "./StoreOfficial";
import StoreTabs from "./StoreTabs";
import styles from "./store-management.module.scss";
import { STORE_TYPE_TABS } from ".";

export enum STORETAB {
  OFFICIAL = "1",
  PENDING = "2",
  REJECTED = "3",
}

interface Props {
  activeTypeTab: string;
}

const StoreTypeTabs = ({ activeTypeTab }: Props) => {
  const { user } = useContext(AppContext);
  const { activeTab, onChange } = useControlTabs(STORETAB.OFFICIAL.toString());
  const isAdmin = user?.merchant_role?.id === MODES.ADMIN;

  if (isAdmin) {
    return (
      <div className={styles.storeTabWrapper}>
        <StoreTabs activeTypeTab={activeTypeTab} activeTab={activeTab} onChange={onChange} />
      </div>
    );
  } else {
    return (
      <div className={styles.wrapper}>
        <StoreOfficial activeTypeTab={activeTypeTab} activeTab={activeTab} />
      </div>
    );
  }
};

export default StoreTypeTabs;
